export default __webpack_public_path__ + "static/media/CoinsReceived.49f16318.svg";